<template>
  <div id="app">
    <v-app>
      <template
        v-if="!$store.state.app.isInitialized"
      >
        <v-container
          class="fill-height justify-center text-center"
          fluid
        >
          <v-progress-circular
            color="secondary"
            indeterminate
          />
        </v-container>
      </template>
      <template
        v-else
      >
        <AppBar />
        <AppNavigation />
        <v-main
          class="grey lighten-5"
        >
          <router-view
            :path="$route.fullPath"
          />
        </v-main>
        <v-progress-linear
          v-if="isRouteLoading"
          color="secondary"
          height="3"
          indeterminate
          :style="{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000 }"
        />
        <v-snackbar-queue
          bottom
          :items="$store.state.notifications.items"
          left
          :timeout="3000"
          @remove="$store.commit('notifications/remove', $event)"
        />
      </template>
    </v-app>
  </div>
</template>

<script>
import { Settings } from 'luxon'

import AppBar from '@/views/AppBar'
import AppNavigation from '@/views/Account/AppNavigation'

export default {
  name: 'App',

  components: {
    AppBar,
    AppNavigation,
  },

  data () {
    return {
      isRouteLoading: false,
      notifications: [],
    }
  },

  watch: {
    '$i18n.locale' () {
      // @TODO: Isn't immediately reflected (need to rerender the page).
      Settings.defaultLocale = this.$i18n.locale
    },
  },

  metaInfo: {
    title: '(surprised pikachu face)',
    titleTemplate: '%s - ServersGG',
  },

  async created () {
    Settings.defaultLocale = this.$i18n.locale

    this.$router.beforeEach((to, from, next) => {
      this.isRouteLoading = true
      next()
    })

    this.$router.afterEach(() => {
      this.isRouteLoading = false
    })
  },
}
</script>

<style>
a {
  text-decoration: none;
}

#app .small-page-width {
  max-width: 550px;
  width: 100%;
}

#app .standard-page-width {
  max-width: 1200px;
}

#app .v-card__title {
  color: #30475f;
  font-size: 16px;
}

#app .v-snack--bottom {
  padding: 20px !important;
}

.position-relative {
  position: relative;
}
</style>
